import { render, staticRenderFns } from "./TriggerWelcome.vue?vue&type=template&id=3bff6a55&"
import script from "./TriggerWelcome.vue?vue&type=script&lang=js&"
export * from "./TriggerWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports